<template>
    <div class="eureka-air flex h-screen w-screen flex-col overflow-y-hidden lg:flex-row">
        <NavBar :headerService="headerService" :navModuleType="NAV_MENU_TYPE.TECH_RESEARCH" />
        <div class="h-full flex-1">
            <router-view></router-view>
        </div>
    </div>
</template>
<script setup lang="ts">
import { NavBar, NAV_MENU_TYPE } from '@eureka/shared/nav-bar';
import { useHeaderService } from './composables/use-header-service';

const { headerService } = useHeaderService();

</script>

<style lang="scss">
.eureka-air {

    .project-create-step,
    .project-create-chat {
        height: 100% !important;
    }
}
</style>
